<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" fixed app v-if="emailToolbar != 'Accedi'">
      <v-flex xs12 v-if="emailToolbar != 'Accedi'">
        <v-card class="indigo lighten-5">
          <v-card-title>
            <v-avatar>
              <v-icon color="blue darken-4" dark size="34">account_circle</v-icon>
            </v-avatar>
            <v-flex class="text-lg-left font-titillium" style="margin-left: 5px">
              <strong style="cursor:pointer;" @click="goToLogin()">{{ emailToolbar }}</strong>
              <!--<strong v-else>{{ emailToolbar }}</strong>-->
              <div style="position:absolute; right:0px; bottom:15px;" v-if="emailToolbar != 'Accedi'">
                <v-btn flat icon color="blue" @click="logout();">
                  <v-icon size="25">exit_to_app</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
      <template>
        <v-layout row wrap class="font-titillium ml-2">
          <v-flex xs12 v-if="currentLoggedUser.email">
            <v-list-tile v-for="item in items" :key="item.heading" :to="item.to">
              <v-list-tile-action>
                <!--v-if="item.heading"-->
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-flex>
        </v-layout>
      </template>
    </v-navigation-drawer>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" dark app fixed>
      <v-flex xs12>
        <v-toolbar-title style="text-align: left; margin-left: -10px" v-if="emailToolbar != 'Accedi'">
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <span class="hidden-sm-and-down font-titillium">
            <img src="../assets/logoSitebuilder.png" style="width:180px; position:absolute;" />
          </span>
        </v-toolbar-title>
      </v-flex>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <router-view/>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<style>
@import url("https://fonts.googleapis.com/css?family=Titillium+Web&display=swap");
.font-titillium {
  font-family: "Titillium Web", sans-serif;
}
</style>
<script>
import config from "../../configuration.json";
import axios from "axios";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    email: "",
    mode: "",
    drawer: null,
    messageSnackbar: "",
    showSearchbox: true,
    loginSuccess: false,
    currentLoggedUser: "",
    items: [
      { icon: "build", text: "Builder", to: "/builder" },
      /*{ icon: "history", text: "Assets", to: "/assets" },*/
      { icon: "perm_identity", text: "Users", to: "/users" }
    ]
  }),
  props: {
    source: String
  },
  computed: {
    ...mapState("authentication", ["emailToolbar", "loginError"]) //mapState è il binding tra le variabili dello store e le views.
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case "authentication/setLoggedUser":
          let temp = this.$store.state.authentication.loggedUser;
          this.currentLoggedUser = JSON.parse(temp);
          break;
      }
    });
  },
  watch: {
    loginError(logoutStatus, oldValue) {
      if(logoutStatus){
        logoutStatus = JSON.parse(logoutStatus);
        this.snackbar = logoutStatus.show;
        this.color = logoutStatus.color;
        this.messageSnackbar = logoutStatus.message;
      }
    }
  },
  methods: {
    goToLogin(){
      this.$router.push("/");
      
    },
    ...mapActions("authentication", ["logout"]),
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      getLoginError: "getLoginError"
    })   
  }
};
</script>